import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Typography from 'gu-ui-kit/Typography'
import styles from '../nav.module.scss'
import { FETCH_NOTIFICATIONS } from 'modules/Recommendations/Audits/store/types'

const REFRESH_COUNTER_TIMEOUT = 600000

const RecommendationMain = React.forwardRef(
  ({ children, className, onClick, title, ...rest }, ref) => {
    const dispatch = useDispatch()
    const { recommendation = 0, audit = 0, benchmark = 0 } = useSelector(
      (state) => ({
        recommendation: state.notifications?.counters?.recommendation,
        audit: state.notifications?.counters?.audit,
        benchmark: state.notifications?.counters?.benchmark,
      }),
      shallowEqual,
    )

    const getCounters = useCallback(() => dispatch({ type: FETCH_NOTIFICATIONS }), [dispatch])

    useEffect(() => {
      const timer = setInterval(getCounters, REFRESH_COUNTER_TIMEOUT)

      return () => clearInterval(timer)
    }, [getCounters])

    useEffect(() => {
      if (!recommendation || !audit || !benchmark) {
        getCounters()
      }
    }, [audit, benchmark, getCounters, recommendation])

    const summary = useMemo(
      () => recommendation + audit + benchmark,
      [recommendation, audit, benchmark],
    )

    return (
      <div
        ref={ref}
        className={className}
        title={title}
        onClick={onClick}
        {...rest}
      >
        {children}
        {summary !== 0 && (
          <Typography
            className={styles['nav__link-badge']}
            component={'span'}
            variant={'Body-10'}
          >
            {summary}
          </Typography>
        )}
      </div>
    )
  },
)

RecommendationMain.displayName = 'RecommendationMain'

export default RecommendationMain

RecommendationMain.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
}
